 const urlHosted = "https://amityamizone.herokuapp.com/";
 const urlDeveloping = "http://localhost:9000/" 
 function getUrl(){
     return urlHosted;
 }

 function convertDate(add)
  {
    var date = new Date();
    date.setDate(new Date().getDate()+add);
    var mm = date.getMonth()+1; 
    var yyyy = date.getFullYear();
    var dd = date.getDate();
    if(dd<10) 
    {
        dd='0'+dd;
    }

    if(mm<10) 
    {
        mm='0'+mm;
    } 
    var convertedDate = yyyy + '-' + mm +'-'+ dd; 
    
    return convertedDate;
  }

 function getDay(add){
    var days = ["Funday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var date = new Date();
    date.setDate(new Date().getDate()+add);
    var day = date.getDay();
    return days[day];
  }

  function getConvertedTime(time){
    time = time.split(' ');
    var convertedTime = time[1] + " " + time[2];
    return convertedTime;
    }

 function get24Hours(time){
     var temp = time.split(" ");
     if(temp[1]==="AM"){
         return temp[0];
     }else{
         temp = temp[0].split(":");
         var hr = temp[0];
         hr = parseInt(hr);
         if(hr!=12){
            hr = hr + 12;
            hr = hr%24;
         }
         var temp = hr + ":" + temp[1] + ":" + temp[2];
         return temp;
     }
 }

 function checkTimeInterval(start, end, current){

    var startDate = new Date(current.getTime());
    startDate.setHours(start.split(":")[0]);
    startDate.setMinutes(start.split(":")[1]);
    startDate.setSeconds(start.split(":")[2]);
    
    var endDate = new Date(current.getTime());
    endDate.setHours(end.split(":")[0]);
    endDate.setMinutes(end.split(":")[1]);
    endDate.setSeconds(end.split(":")[2]);
    
    if(startDate>current){
        return 1;
    }
    if(startDate<=current && endDate>=current){
        return 2;
    }
    if(endDate<current){
        return 3;
    }
 }

  export {getUrl, getDay, convertDate, getConvertedTime, get24Hours, checkTimeInterval, }